import React from 'react';
import { useTable, Column } from 'react-table';
import './table.css';
import { TableData } from '../ModalConfirmPayment/ModalConfirmPayment.interface';

export interface InvoiceTableProps {
	columns: Column<TableData>[];
	data: TableData[];
}

const InvoiceTable: React.FC<InvoiceTableProps> = ({ columns, data }) => {
	const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
		useTable({ columns, data });

	return (
		<table className="result-table" {...getTableProps()}>
			<thead>
				{headerGroups.map((headerGroup, index) => (
					<tr {...headerGroup.getHeaderGroupProps()} key={index}>
						{headerGroup.headers.map((column) => {
							return (
								<th {...column.getHeaderProps()}>{column.render('Header')}</th>
							);
						})}
					</tr>
				))}
			</thead>
			<tbody {...getTableBodyProps()}>
				{rows.map((row, index) => {
					prepareRow(row);
					return (
						<tr {...row.getRowProps()} key={index}>
							{row.cells.map((cell, i) => {
								return (
									<td {...cell.getCellProps()} key={i}>
										{cell.render('Cell')}
									</td>
								);
							})}
						</tr>
					);
				})}
			</tbody>
		</table>
	);
};
export default InvoiceTable;
